<template>
  <div class="index" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="拼命加载中">
    <div class="index_title">
      <div class="index_title_box">
        <div>建设领域现场施工专业人员培训测试系统</div>
        <img class="index_title_img" src="@/assets/img/full-screen.png" @click="buttoncli"/>
      </div>
    </div>
    <!--    个人信息栏    -->
    <div class="index_message">
      <div class="message_left">
        <div class="message_left_name">
          相关信息：
          <div class="message_left_name_hr"></div>
        </div>
        <div class="message_left_de">
          <div class="name">身份证号：{{user.identityCard}}</div>
          <div class="name">姓名：{{user.realName}}</div>
          <div class="name">测试时长：{{exam_time_number}}分钟</div>
          <div class="name">题目总数：{{list.length}}</div>
        </div>
      </div>
      <div class="message_right">

        <div class="name">测试状态：<span>{{ceshi}}</span></div>
        <div class="name">剩余时间：</div>
        <div class="count">
          <TimerCountdown
                  :deadline="remainTime"
                  :complete-zero="true"
                  :left-second="0"
                  :ignore-day="true"
                  @done="endFn"
          />
        </div>
        <div class="counter" @click="clickCalculator">{{calculator_show?'关闭计算器':'打开计算器'}}</div>
      </div>
    </div>
    <!--  主体内容      -->
    <div class="index_main">
      <div class="main_left">
        <div class="main_left_centent">

          <!--  左侧题目    -->
          <div class="one">
            <template v-for="(item,index) in category_list">
              <div>
                <div class="one_title">
                  {{item}}
                  <div class="one_title_hr"></div>
                </div>
                <div class="one_name">
                  <template v-if="item=='单选题'">
                    <div class="name_value" v-for="(t,tindex) in onelist" :key="tindex"
                         :class="[cindex==tindex && type==t.type?'name_value_blue':'',t.select!==null?'name_value_green':'',t.checked==true?'name_value_check':'']"
                         @click="clickSingle(tindex,t.type)">{{tindex+1}}
                    </div>
                  </template>
                  <template v-if="item=='判断题'">
                    <div class="name_value" v-for="(t,tindex) in judge" :key="tindex"
                         :class="[cindex==tindex && type==t.type?'name_value_blue':'',t.select!==null?'name_value_green':'',t.checked==true?'name_value_check':'']"
                         @click="clickSingle(tindex,t.type)">{{tindex+1}}
                    </div>
                  </template>
                  <template v-if="item=='多选题'">
                    <div class="name_value" v-for="(t,tindex) in morelist" :key="tindex"
                         :class="[cindex==tindex && type==t.type?'name_value_blue':'',t.select.length>0?'name_value_green':'',t.checked==true?'name_value_check':'']"
                         @click="clickSingle(tindex,t.type)">{{tindex+1}}
                    </div>
                  </template>
                  <template v-if="item=='案例分析题'">
                    <div class="name_value" v-for="(t,tindex) in combination" :key="tindex"
                         :class="[cindex==tindex && type=='案例分析题'?'name_value_blue':'',t.is_pitch?'name_value_green':'',t.checked==true?'name_value_check':'']"
                         @click="clickSingle(tindex,'案例分析题')">{{tindex+1}}
                    </div>
                  </template>
                </div>
              </div>

            </template>
          </div>
        </div>

        <!--    待查       -->
        <div class="examine">
          <template v-for="(item,index) in onelist" v-if="type=='单选题'">
            <el-checkbox @change="changeUp" v-model="item.checked" v-if="cindex===index">待查</el-checkbox>
          </template>

          <template v-for="(item,index) in morelist" v-if="type=='多选题'">
            <el-checkbox @change="changeUp" v-model="item.checked" v-if="cindex===index">待查</el-checkbox>
          </template>

          <template v-for="(item,index) in judge" v-if="type=='判断题'">
            <el-checkbox @change="changeUp" v-model="item.checked" v-if="cindex===index">待查</el-checkbox>
          </template>

          <template v-for="(item,index) in combination" v-if="type=='案例分析题'">
            <el-checkbox @change="changeUp" v-model="item.checked" v-if="cindex===index">待查</el-checkbox>
          </template>

        </div>

      </div>
      <div class="main_centre">
        <div class="centre_answer">

          <!--        放大缩小            -->
          <div class="size_of_the">
            <div>字号大小：</div>
            <div class="icon" @click="clickSmall">
              <img src="@/assets/img/small.png">
            </div>
            <div class="icon" @click="clickBig">
              <img src="@/assets/img/big.png">
            </div>
          </div>
          <!--                    <div class="answer_hint">-->
          <!--                        <div v-if="type=='单选题'">当前题目-单选题</div>-->
          <!--                        <div v-if="type=='多选题'">当前题目-多选题</div>-->
          <!--                        <div v-if="type=='判断题'">当前题目-判断题</div>-->
          <!--                        <div v-if="type=='案例分析题'">当前题目-案例分析题</div>-->
          <!--                    </div>-->
          <!--    答题区    -->


          <!--     判断题  -->
          <template v-for="(item,index) in judge">
            <div class="answer_hint" v-if="type=='判断题' && cindex==index">
              当前题目-判断题(每题{{item.PaperQuestion.score}}分，每题的备选项中只有1个最符合题意。)
            </div>
            <div class="answer_single" :style="{ fontSize: postFontSize + 'px' }"
                 v-if="type=='判断题' && cindex==index">
              <div class="single_title">
                {{index+1}}、{{item.ask}}
                <span class="is_hint" v-if="is_hint==1" @click="clickHint">
                                    <span>[提示]</span>
                                </span>
              </div>
              <!--    单选背景图    -->
              <div class="single_bgimg" v-if="item.background_img">
                <el-tooltip class="item" effect="dark" content="点击图片放大预览" placement="right-end">
                  <img v-image-preview :src="item.background_img"/>
                </el-tooltip>
              </div>
              <div class="single_imgs" v-if="item.topic_img">
                <img v-image-preview :src="item.topic_img"/>
              </div>
              <div class="single_radio">
                <el-radio-group class="single_radio_group" v-model="item.select">
                  <el-radio :label="t.title" v-for="(t,indexs) in item.questionlist"
                            v-if="t.images_url==''"><span :style="{ fontSize: postFontSize + 'px' }">{{t.title}}.{{t.content}}</span>
                  </el-radio>
                  <el-radio class="single_radio_group_tu" :label="t.title"
                            v-for="(t,indexs) in item.questionlist" v-if="t.images_url">
                    <div class="radio_img">
                      <div :style="{ fontSize: postFontSize + 'px' }">{{t.title}}</div>
                      <img v-image-preview :src="t.images_url"/>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>

              <template v-if="is_hint==1">
                <div v-if="is_model==1" class="single_answer">
                  <div class="answe_a">参考答案：<span>{{item.answer}}</span></div>
                  <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                    <div>解析：</div>
                    <template v-if="item.analysis!==''">
                      <div v-html="item.analysis"></div>
                    </template>
                    <template v-else>
                      <div class="no_size">暂无</div>
                    </template>
                  </div>
                  <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                    <div>笔记：</div>
                    <template v-if="item.notes!==''">
                      <div v-html="item.notes"></div>
                    </template>
                    <template>
                      <div class="no_size">暂无</div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </template>

          <!--     单选题  -->
          <template v-for="(item,index) in onelist">
            <div class="answer_hint" v-if="type=='单选题' && cindex==index">
              当前题目-单选题(每题{{item.PaperQuestion.score}}分，每题的备选项中只有1个最符合题意。)
            </div>
            <div class="answer_single" :style="{ fontSize: postFontSize + 'px' }"
                 v-if="type=='单选题' && cindex==index">

              <div class="single_title">
                {{index+1}}、{{item.ask}}
                <span class="is_hint" v-if="is_hint==1" @click="clickHint">
                                    <span>[提示]</span>
                                </span>
              </div>
              <!--    单选背景图    -->
              <div class="single_bgimg" v-if="item.background_img">
                <el-tooltip class="item" effect="dark" content="点击图片放大预览" placement="right-end">
                  <img v-image-preview :src="item.background_img"/>
                </el-tooltip>
              </div>
              <div class="single_imgs" v-if="item.topic_img">
                <img v-image-preview :src="item.topic_img"/>
              </div>
              <div class="single_radio">
                <el-radio-group class="single_radio_group" v-model="item.select">
                  <el-radio :label="t.title" v-for="(t,indexs) in item.questionlist"
                            v-if="t.images_url==''"><span :style="{ fontSize: postFontSize + 'px' }">{{t.title}}.{{t.content}}</span>
                  </el-radio>
                  <el-radio class="single_radio_group_tu" :label="t.title"
                            v-for="(t,indexs) in item.questionlist" v-if="t.images_url">
                    <div class="radio_img">
                      <div :style="{ fontSize: postFontSize + 'px' }">{{t.title}}</div>
                      <img v-image-preview :src="t.images_url"/>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>

              <template v-if="is_hint==1">
                <div v-if="is_model==1" class="single_answer">
                  <div class="answe_a">参考答案：<span>{{item.answer}}</span></div>
                  <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                    <div>解析：</div>
                    <template v-if="item.analysis!==''">
                      <div v-html="item.analysis"></div>
                    </template>
                    <template v-else>
                      <div class="no_size">暂无</div>
                    </template>
                  </div>
                  <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                    <div>笔记：</div>
                    <template v-if="item.notes!==''">
                      <div v-html="item.notes"></div>
                    </template>
                    <template>
                      <div class="no_size">暂无</div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </template>


          <!--     多选题    -->
          <template v-for="(item,index) in morelist">
            <div class="answer_hint" v-if="type=='多选题' && cindex==index">
              <template v-if="item.PaperQuestion.leak_score!==0">
                当前题目-多选题(每题{{item.PaperQuestion.score}}分，每题的备选项中只有2个或2个以上符合题意;全对得{{item.PaperQuestion.score}}分，错选不得分；漏题每题{{item.PaperQuestion.leak_score}}分。)
              </template>
              <template v-else>
                当前题目-多选题(每题{{item.PaperQuestion.score}}分，每题的备选项中只有2个或2个以上符合题意;全对得{{item.PaperQuestion.score}}分，错选不得分；选不全题得{{item.PaperQuestion.partial_score}}分。)
              </template>
            </div>
            <div class="answer_single" :style="{ fontSize: postFontSize + 'px' }"
                 v-if="type=='多选题' && cindex==index">
              <div class="single_title">
                {{index+1}}、{{item.ask}}
                <span class="is_hint" v-if="is_hint==1" @click="clickHint">
                                    <span>[提示]</span>
                                </span>
              </div>
              <!--    单选背景图    -->
              <div class="single_bgimg" v-if="item.background_img">
                <el-tooltip class="item" effect="dark" content="点击图片放大预览" placement="right-end">
                  <img v-image-preview :src="item.background_img"/>
                </el-tooltip>
              </div>
              <div class="single_imgs" v-if="item.topic_img">
                <img v-image-preview :src="item.topic_img"/>
              </div>

              <div class="single_radio">
                <el-checkbox-group class="single_checkbox-group" v-model="item.select">
                  <el-checkbox :label="t.title" v-for="(t,tindex) in item.questionlist"><span
                          :style="{ fontSize: postFontSize + 'px' }">{{t.title}}.{{t.content}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <template v-if="is_hint==1">
                <div v-if="is_model==1" class="single_answer">
                  <div class="answe_a">参考答案：<span>{{item.answer}}</span></div>
                  <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                    <div>解析：</div>
                    <template v-if="item.analysis!==''">
                      <div v-html="item.analysis"></div>
                    </template>
                    <template v-else>
                      <div class="no_size">暂无</div>
                    </template>
                  </div>
                  <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                    <div>笔记：</div>
                    <template v-if="item.notes!==''">
                      <div v-html="item.notes"></div>
                    </template>
                    <template>
                      <div class="no_size">暂无</div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </template>

          <!--     案例分析题    -->
          <template v-for="(item,index) in combination">
            <div class="answer_hint" v-if="type=='案例分析题' && cindex==index">当前题目-案例分析题</div>
            <div class="answer_single" :style="{ fontSize: postFontSize + 'px' }"
                 v-if="type=='案例分析题' && cindex===index">
              <!--     案例背景内容             -->
              <div class="single_case" :style="{ fontSize: postFontSize + 'px' }" v-if="item.background">
                {{index+1}}、{{item.background}}
              </div>
              <!--    背景图             -->
              <div class="single_bgimg" v-if="item.background_img">
                <el-tooltip class="item" effect="dark" content="点击图片放大预览" placement="right-end">
                  <img v-image-preview :src="item.background_img"/>
                </el-tooltip>
              </div>
              <!--        题目列表       -->
              <div v-for="(c,cindex) in item.data">
                <div class="single_title">
                  {{cindex+1}}、{{c.ask}}
                  <span class="is_hint" v-if="is_hint==1" @click="clickHint">
                                        <span>[提示]</span>
                                    </span>
                </div>
                <div class="single_imgs" v-if="c.topic_img">
                  <img v-image-preview :src="c.topic_img"/>
                </div>
                <div class="single_radio" v-if="c.type!=='案例/多选题'">
                  <el-radio-group class="single_radio_group" v-model="c.select">
                    <el-radio @change="changeRadio(index)" :label="t.title"
                              v-for="(t,indexs) in c.questionlist" v-if="t.images_url==''"><span
                            :style="{ fontSize: postFontSize + 'px' }">{{t.title}}.{{t.content}}</span>
                    </el-radio>
                    <el-radio @change="changeRadio(index)" class="single_radio_group_tu"
                              :label="t.title" v-for="(t,indexs) in item.questionlist"
                              v-if="t.images_url">
                      <div class="radio_img">
                        <div :style="{ fontSize: postFontSize + 'px' }">{{t.title}}</div>
                        <img v-image-preview :src="t.images_url"/>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>

                <div class="single_radio" v-else>
                  <el-checkbox-group @change="changeRadio(index)" class="single_checkbox-group"
                                     v-model="c.select">
                    <el-checkbox :label="t.title" v-for="(t,tindex) in c.questionlist"><span
                            :style="{ fontSize: postFontSize + 'px' }">{{t.title}}.{{t.content}}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>

                <template v-if="is_hint==1">
                  <div v-if="is_model==1" class="single_answer">
                    <div class="answe_a">参考答案：<span>{{c.answer}}</span></div>
                    <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                      <div>解析：</div>
                      <template v-if="c.analysis!==''">
                        <div v-html="c.analysis"></div>
                      </template>
                      <template v-else>
                        <div class="no_size">暂无</div>
                      </template>
                    </div>
                    <div class="answer_b" :style="{ fontSize: postFontSize + 'px' }">
                      <div>笔记：</div>
                      <template v-if="c.notes!==''">
                        <div v-html="c.notes"></div>
                      </template>
                      <template>
                        <div class="no_size">暂无</div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>


        </div>
        <div class="centre_operate">
          <div class="operate_up">
            <div class="operate_up_c" @click="oNup">上一题</div>
            <div class="operate_up_c" @click="oNnext">下一题</div>
            <div class="operate_up_c" @click="oNerror">报错</div>
          </div>
          <div class="operate_deal" @click="toggleSubmit">提交试卷</div>
        </div>
      </div>

      <!--     摄像头区域       -->
      <div class="main_right">
        <div class="main_right_hint">摄像头区域</div>
        <div class="main_right_play">
          <div class="paly_video">
            <template v-if="is_facility">
              <video ref="video" class="ta_video" width="100%" height="240" autoplay></video>
            </template>
            <div class="is_camera" v-else>
              没有发现摄影头
            </div>
          </div>
<!--          <div class="paly_take" v-if="userInfo.user">-->
<!--            <img :src="userInfo.user.avatarUrl"/>-->
<!--          </div>-->
          <div class="paly_notice">
            <div>注意事项：</div>
            <div class="notice_cent">请遵守考场纪律，勿交头接耳，否则将按照作弊处理</div>
          </div>
        </div>
      </div>
    </div>

    <!--  确定交卷提示框？      -->
    <div class="index_roll" v-if="hand_roll" @touchmove.prevent>
      <div class="head">
        <div class="head_title">提示</div>
        <div class="head_icon" @click="onhintClose"><i class="el-icon-close"></i></div>
      </div>
      <div class="hint">
        <div class="hint_img"><img src="@/assets/img/wen.png"/></div>
        <div class="hint_name">是否确认提交试卷？</div>
      </div>
      <div class="operation">
        <button class="operation_on" @click="onReminder">确定</button>
        <button class="operation_on" @click="onhintClose">取消</button>
      </div>
    </div>

    <!--  成绩结果       -->
    <div class="index_reminder" v-if="hint_show" @touchmove.prevent>
      <div class="head">测试成绩</div>
      <div class="grade">您本次测试成绩：<span>{{score}}分</span></div>
      <div class="confirm">
        <div class="confirm_hr"></div>
        <div class="confirm_on" @click="onConfirm">
          <div>确</div>
          <div>定</div>
        </div>
        <div class="confirm_hr"></div>
      </div>
    </div>

    <!--计算器-->
    <div class="index_calculator" v-drag v-if="calculator_show">
      <div class="calculator">
        <div class="calculator_close" @click="clickCalculator">
          <i class="el-icon-close"></i>
        </div>
        <button class="toggle-button">
          <p>计算器</p>
        </button>
        <div class="results">
          <div class="results_value">{{current}}</div>
        </div>
        <div class="mode">
          <button class="button" @click="press">(</button>
          <button class="button" @click="press">)</button>
          <button class="button" @click="press">C</button>
          <button class="button"></button>
          <button class="button" @click="press">7</button>
          <button class="button" @click="press">8</button>
          <button class="button" @click="press">9</button>
          <button class="button" @click="press">/</button>
          <button class="button" @click="press">4</button>
          <button class="button" @click="press">5</button>
          <button class="button" @click="press">6</button>
          <button class="button" @click="press">x</button>


          <button class="button" @click="press">1</button>
          <button class="button" @click="press">2</button>
          <button class="button" @click="press">3</button>
          <button class="button" @click="press">-</button>
          <button class="button" @click="press">0</button>
          <button class="button" @click="press">.</button>
          <button class="button" @click="press">=</button>
          <button class="button" @click="press">+</button>
        </div>
      </div>
    </div>


    <!--   报错      -->
    <el-dialog title="题目报错" :before-close="dialogclose" :visible.sync="dialogFormVisible">
      <el-form>

        <el-form-item label="错误题目" :label-width="formLabelWidth">
          <el-select v-model="error.question_id" placeholder="请选择错误题目" v-if="type=='案例分析题'">
            <el-option :label="item.ask" :value="item.id" v-for="(item,index) in analysis"></el-option>
          </el-select>
          <div v-else>{{error_title}}</div>
        </el-form-item>
        <el-form-item label="错误选项" :label-width="formLabelWidth">
          <el-checkbox-group v-model="result" @change="onChangeoption">
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.title">{{item.title}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="其它错误" :label-width="formLabelWidth" v-if="is_form_input">
          <el-input type="textarea" v-model="error.centent" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogclose">取 消</el-button>
        <el-button type="primary" @click="dialogDetermine">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
    import screenfull from 'screenfull'
    import {GetQuestionItemByData, PostAddByData, GetExamInfoById, PostQuestionErrorData} from '@/api/course'
    import {GetDataByListApplet} from '@/api/temporary'
    import { Base64 } from 'js-base64';
    import {mapGetters} from "vuex";

    export default {
        name: "index",
        data() {
            return {
                is_form_input:false,
                result:[],
                columns:[],//选项列表
                exam_time_number:0,//考试时间
                info: {},
                error_title: "",
                analysis: [], //案例分析报错
                dialogFormVisible: false,
                formLabelWidth: '120px',
                error: {
                    question_id: undefined, //题目id
                    centent: "", //报错内容
                },//报错
                type_arr: [], //左侧类目
                onelist: [],  //单选题
                judge: [],  //判断题
                morelist: [], //  多选题
                combination: [], //组合
                list: [], //数据
                category_list: [], //左侧类目


                start_time: 0,//开始开始时间
                end_time: 0,//结束时间
                fullscreenLoading: true,
                exam_id: undefined,
                class_id: undefined,
                paper_id: undefined,
                qu_all: [],
                ceshi: "测试中", //测试状态
                hand_roll: false, //确定交卷提示框？
                postexam: [],//提交后台数据结构
                is_facility: true, //是否有摄像头
                isFullscreen: false, //全屏
                postFontSize: "16", //字体
                calculator_show: false, //计算器
                current: '', //计算器结果
                remainTime: 1, //总秒数
                score: 0, //分数
                hint_show: false,
                user_id: undefined,
                type: "单选题",
                cindex: 0, //当前题目
                is_hint: 1, //1.练习  2.考试
                is_model: 2, //提示默认隐藏
                user:{}
            }
        },
        computed:{
            ...mapGetters(['userinfo'])
        },
        created() {
            this.is_hint = this.$route.query.is_hint  //1.练习  2.考试
            let user = JSON.parse(this.userinfo)
            this.user = user
            this.user_id = user.user_id
            this.getPost()
            this.getoption()
        },

        //拖动
        directives: {
            drag: {
                // 指令的定义
                bind: function (el) {
                    let oDiv = el;  // 获取当前元素
                    oDiv.onmousedown = (e) => {
                        // 算出鼠标相对元素的位置
                        let disX = e.clientX - oDiv.offsetLeft;
                        let disY = e.clientY - oDiv.offsetTop;

                        document.onmousemove = (e) => {
                            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                            let left = e.clientX - disX;
                            let top = e.clientY - disY;

                            oDiv.style.left = left + 'px';
                            oDiv.style.top = top + 'px';
                        };

                        document.onmouseup = (e) => {
                            document.onmousemove = null;
                            document.onmouseup = null;
                        }
                    }
                }
            }
        },
        mounted() {
            this.exam_id = this.$route.query.exam_id
            this.class_id = this.$route.query.class_id
            this.checkshebei()
            this.callCamera()

        },
        methods: {
            onChangeoption(event){
                console.log(event,"detail")
                let result = event
                let index = result.indexOf('其它错误');
                if(index>=0){
                    this.is_form_input = true
                }
                else{
                    this.is_form_input = false
                }
                this.result = result
            },
            getoption(){
                GetDataByListApplet().then(res => {
                    console.log(res.data,"选项")
                    this.columns = res.data
                })
            },
            async getPost(){
                let that = this
                let temp = {
                    id: that.$route.query.exam_id,
                  type:2,//加密
                }
                let remainTime = 0
                await GetExamInfoById(temp).then(res => {
                  let data=res.data;
                  data=Base64.decode(res.data)
                  data=JSON.parse(data);
                  let q_list = data.paper.question
                    that.info = data
                    let type_arr = data.paper.type_arr.split(",");
                    that.type_arr = type_arr
                    that.paper_id = data.paper_id
                    q_list.forEach(item => {
                        that.qu_all.push(item.question_id)
                    })
                    that.getlist()
                    that.exam_time_number = data.exam_time_number
                    let time = parseInt(data.exam_time_number *60)
                    remainTime = time
                })
                that.remainTime = remainTime

            },
            //提示关闭打开
            clickHint() {
                let index = this.is_model
                if (index == 1) {
                    this.is_model = 2
                } else {
                    this.is_model = 1
                }
            },
            //弹出报错
            oNerror() {
                this.dialogFormVisible = true

                let error_title = ""
                let error_id = undefined
                let analysis = []

                let type = this.type
                let cindex = this.cindex
                let onelist = this.onelist
                let judge = this.judge  //判断
                let morelist = this.morelist //  多选题
                let combination = this.combination //组合
                if (type == '单选题') {
                    for (let i = 0; i < onelist.length; i++) {
                        if (cindex == i) {
                            error_title = onelist[i].ask
                            error_id = onelist[i].id
                        }
                    }
                } else if (type == '多选题') {
                    for (let i = 0; i < morelist.length; i++) {
                        if (cindex == i) {
                            error_title = morelist[i].ask
                            error_id = morelist[i].id
                        }
                    }
                } else if (type == '判断题') {
                    for (let i = 0; i < judge.length; i++) {
                        if (cindex == i) {
                            error_title = judge[i].ask
                            error_id = judge[i].id
                        }
                    }
                } else {

                    for (let i = 0; i < combination.length; i++) {
                        if (cindex == i) {
                            analysis = combination[i].data
                        }
                    }
                }

                this.error_title = error_title
                this.error.question_id = error_id
                this.analysis = analysis
            },
            dialogclose() {
                this.dialogFormVisible = false
                this.error.centent = ''
                this.is_form_input = false
                this.result = []

            },
            //报错确定
            dialogDetermine() {
                this.dialogFormVisible = false
                let temp = this.error
                temp.user_id = this.user_id //用户id
                temp.inst_id = this.info.inst_id //机构id
                temp.exam_id = this.exam_id //所属考试id
                temp.paper_id = this.paper_id //所属试卷id


                let result  = this.result
                let indexs = result.indexOf('其它错误')
                if(indexs>=0){
                    let items = result
                    for(let i=0;i<result.length;i++){
                        if(result[i]=='其它错误'){
                            items.splice(i,1)
                        }
                    }
                    items.push(temp.centent)
                    temp.centent = items.join(";")
                }
                else{
                    temp.centent = result.join(";")
                }

                PostQuestionErrorData(temp).then(res => {

                    this.$notify({
                        title: '提交成功',
                        message: '题目报错提交成功',
                        type: 'success'
                    });
                    this.error.centent = ''
                    this.is_form_input = false
                    this.result = []

                })
            },
            changeUp() {
                this.$forceUpdate()
            },
            //提交的数据
            handelPost() {
                let start_time = this.start_time
                let end = new Date
                let question_list = []
                let score = 0;


                let onelist = this.onelist //单选
                let judge = this.judge //判断
                let morelist = this.morelist //多选
                let combination = this.combination //案例分析


                //单选题
                if (onelist.length > 0) {
                    onelist.forEach(item => {
                        let is_correct = 2
                        if (item.answer === item.select) {
                            score = score + item.PaperQuestion.score
                            is_correct = 1
                        }
                        let select = '';
                        if (item.select !== null) {
                            select = item.select
                        }
                        question_list.push(
                            {
                                question_id: item.id,  //题目id
                                is_correct, //是否正确答案
                                select,
                            }
                        )
                    })
                }

                //判断题
                if (judge.length > 0) {
                    judge.forEach(item => {
                        let is_correct = 2
                        if (item.answer === item.select) {
                            score = score + item.PaperQuestion.score
                            is_correct = 1
                        }
                        let select = '';
                        if (item.select !== null) {
                            select = item.select
                        }
                        question_list.push(
                            {
                                question_id: item.id,  //题目id
                                is_correct, //是否正确答案
                                select,
                            }
                        )
                    })
                }
                //多选题
                if (morelist.length > 0) {
                    morelist.forEach(item => {
                        let is_correct = 2
                        let ans = item.select.sort()
                        let select = ans.join('') // 格式如：ABD
                        if (item.answer === select) {
                            score = score + item.PaperQuestion.score
                            question_list.push(
                                {
                                    question_id: item.id,  //题目id
                                    is_correct:1, //是否正确答案
                                    select:select, //选择答案
                                }
                            )
                        }

                        let answer = item.answer.split('') //正确答案
                        if (select ==="") { //当用户没有进行答案选择时
                            question_list.push(
                                {
                                    question_id: item.id,  //题目id
                                    is_correct, //是否正确答案
                                    select:'', //选择答案
                                }
                            )
                        }
                        if(item.answer !== select && select !==""){
                            let sel=item.select.sort()//用户选择答案
                            let is_error=false;
                            console.log(sel,"sel")

                            sel.forEach(si=>{
                                console.log(answer.indexOf(si),answer)
                                if(answer.indexOf(si)===-1){
                                    is_error=true
                                }
                            })
                            if(is_error===true){
                                question_list.push(
                                    {
                                        question_id: item.id,  //题目id
                                        is_correct:2, //是否正确答案
                                        select:select, //选择答案
                                    }
                                )
                            }else{
                                let sellength = sel.length
                                console.log(answer.length,sel.length,'在没有错误的场景下')
                                if (item.PaperQuestion.leak_score !== 0) {
                                    score = score + (item.PaperQuestion.leak_score * sellength)
                                } else {
                                    score = score + item.PaperQuestion.partial_score
                                }
                                question_list.push(
                                    {
                                        question_id: item.id,  //题目id
                                        is_correct:3, //是否正确答案
                                        select:select, //选择答案
                                    }
                                )

                            }
                        }
                    })
                }

                //案例分析题
                let temps = []
                if (combination.length > 0) {
                    combination.forEach(item => {
                        temps.push(...item.data)
                    })
                }
                if (temps.length > 0) {
                    temps.forEach(item => {
                        let is_correct = 2
                        if (Array.isArray(item.select)) {
                            let ans = item.select.sort()
                            let select = ans.join('') // 格式如：ABD

                            if (item.answer === select) {
                                score = score + item.PaperQuestion.score
                                question_list.push(
                                    {
                                        question_id: item.id,  //题目id
                                        is_correct:1, //是否正确答案
                                        select:select, //选择答案
                                    }
                                )
                            }

                            let answer = item.answer.split('') //正确答案
                            if (select ==="") { //当用户没有进行答案选择时
                                question_list.push(
                                    {
                                        question_id: item.id,  //题目id
                                        is_correct, //是否正确答案
                                        select:'', //选择答案
                                    }
                                )
                            }
                            if(item.answer !== select && select !==""){
                                let sel=item.select.sort()//用户选择答案
                                let is_error=false;

                                sel.forEach(si=>{
                                    console.log(answer.indexOf(si),answer)
                                    if(answer.indexOf(si)===-1){
                                        is_error=true
                                    }
                                })
                                if(is_error===true){
                                    question_list.push(
                                        {
                                            question_id: item.id,  //题目id
                                            is_correct:2, //是否正确答案
                                            select:select, //选择答案
                                        }
                                    )
                                }else{
                                    let sellength = sel.length
                                    console.log(answer.length,sel.length,'在没有错误的场景下')
                                    if (item.PaperQuestion.leak_score !== 0) {
                                        score = score + (item.PaperQuestion.leak_score * sellength)
                                    } else {
                                        score = score + item.PaperQuestion.partial_score
                                    }
                                    question_list.push(
                                        {
                                            question_id: item.id,  //题目id
                                            is_correct:3, //是否正确答案
                                            select:select, //选择答案
                                        }
                                    )

                                }
                            }
                        } else {
                            if (item.answer === item.select) {
                                score = score + item.PaperQuestion.score
                                is_correct = 1
                            }
                            let select = '';
                            if (item.select !== "") {
                                select = item.select
                            }
                            question_list.push(
                                {
                                    question_id: item.id,  //题目id
                                    is_correct, //是否正确答案
                                    select,
                                }
                            )
                        }
                    })
                }

                console.log(temps, "temps")

                // return;
                let exam = {//提交记录
                    user_id: this.user_id,//提交的用户
                    score,//提交的分数
                    exam_id: this.exam_id,//所属考试
                    paper_id: this.paper_id,//所属试卷
                    class_id: this.class_id,
                    duration: parseInt((end.getTime() - start_time))//考试时长
                }
                let postexam = {
                    exam,
                    question_list
                }
                console.log(postexam, "postexam")
                this.postexam = postexam
                this.score = score
            },
            //提交试卷
            toggleSubmit() {
                this.hand_roll = true
                this.handelPost()
            },
            //取消交卷
            onhintClose() {
                this.hand_roll = false
            },
            //确定交卷
            onReminder() {
                let postexam = this.postexam
                this.ceshi = '测试结束'

                PostAddByData(postexam).then(res => {

                    this.hand_roll = false
                    this.hint_show = !this.hint_show
                })
            },
            //成绩确定
            onConfirm() {
                this.hint_show = !this.hint_show
                this.$router.push({path: '/my'})
            },
            //用于案例分析题排序
            compare(property) {
                return function (obj1, obj2) {
                    return obj1[property] - obj2[property];
                }
            },
            getlist() {
                let type_arr = this.type_arr
                let start_time = new Date
                this.start_time = start_time.getTime()
                let temp = {
                    list: this.qu_all,
                    paper_id: this.paper_id
                }
                this.fullscreenLoading = true;
                GetQuestionItemByData(temp).then(res => {
                    let answer = res.data


                    let onelist = [] //单选
                    let morelist = []  //多选
                    let judge = []  //判断
                    let combination = [] //案例分析题
                    for (let i = 0; i < answer.length; i++) {
                        answer[i].checked = false
                        if (answer[i].type == '单选题') {
                            onelist.push(answer[i])
                        }
                        if (answer[i].type == '多选题') {
                            answer[i].select = []
                            morelist.push(answer[i])
                        }
                        if (answer[i].type == '判断题') {
                            judge.push(answer[i])
                        }
                        if (answer[i].type == '案例/单选题' || answer[i].type == '案例/多选题' || answer[i].type == '案例/判断题') {
                            if (answer[i].type == '案例/多选题') {
                                answer[i].select = []

                            }

                            combination.push(answer[i])
                        }
                    }



                    //数据重组
                    let anlist = []
                    for (let i = 0; i < type_arr.length; i++) {
                        if (type_arr[i] == '单选题') {
                            anlist.push(...onelist)

                        }
                        if (type_arr[i] == '多选题') {
                            anlist.push(...morelist)

                        }
                        if (type_arr[i] == '判断题') {
                            anlist.push(...judge)

                        }
                    }

                    for (let i = 0; i < type_arr.length; i++){

                        if (type_arr[i] == '单选题') {
                            if(onelist.length>0){
                                this.type = '单选题'
                                break;
                            }

                        }
                        if (type_arr[i] == '多选题') {
                            if(morelist.length>0){
                                this.type = '多选题'
                                break;
                            }

                        }
                        if (type_arr[i] == '判断题') {
                            if(judge.length>0){
                                this.type = '判断题'
                                break;
                            }

                        }
                    }


                    let map = {}
                    let dest = []
                    if (combination.length > 0) {
                        for (let i = 0; i < combination.length; i++) {
                            var ai = combination[i]
                            if (!map[ai.background]) {
                                dest.push({
                                    checked: false,
                                    background: ai.background,
                                    background_img: ai.background_img,
                                    data: [ai]
                                });
                                map[ai.background] = ai
                            } else {
                                for (let j = 0; j < dest.length; j++) {
                                    let dj = dest[j];
                                    if (dj.background == ai.background) {
                                        dj.data.push(ai);
                                        break;
                                    }
                                }

                            }
                        }
                    }

                    //案例分析题根据number排序
                    for (let i = 0; i < dest.length; i++) {
                        dest[i].is_pitch = false
                        dest[i].data = dest[i].data.sort(this.compare('number'))
                    }



                    if (combination.length > 0) {
                        anlist.push(...dest)
                    }
                    //对弹出层没有内容的类目隐藏操作
                    let category = []
                    anlist.forEach(item => {
                        category.push(item.type)
                    })
                    let category_temp = Array.from(new Set(category));
                    let category_list = []
                    category_temp.forEach(item => {
                        if (item == '单选题' || item == '多选题' || item == '判断题') {
                            category_list.push(item)
                        }
                    })
                    if (combination.length > 0) {
                        category_list.push('案例分析题')
                    }




                    this.fullscreenLoading = false,
                        this.category_list = category_list,
                        this.list = anlist,
                        this.onelist = onelist,
                        this.morelist = morelist,
                        this.judge = judge,
                        this.combination = dest
                })
            },
            //下面实现计算器
            clickCalculator() {
                //点击打开计算器
                this.calculator_show = !this.calculator_show
            },
            //计算器
            press(event) {
                var me = this;
                var key = event.target.textContent;
                if (key != '=' && key != 'C' && key != 'x' && key != '/' && key != '√' && key != "x ²" && key != "%" && key != "<=" && key != "±" && key != "sin" && key != "cos" && key != "tan" && key != "log" && key != "ln" && key != "x^" && key != "x !" && key != "π" && key != "e" && key != "rad" && key != "∘") {
                    me.current += key;
                } else if (key === '=') {
                    if (me.current.indexOf('^') > -1) {
                        var base = me.current.slice(0, me.current.indexOf('^'));
                        var exponent = me.current.slice(me.current.indexOf('^') + 1);
                        me.current = eval('Math.pow(' + base + ',' + exponent + ')');
                    } else {
                        me.current = eval(me.current);
                    }
                } else if (key === 'C') {

                    me.current = '';
                } else if (key === 'x') {

                    me.current += '*';
                } else if (key === '/') {

                    me.current += '/';
                } else if (key === '+') {

                    me.current += '+';
                } else if (key === '-') {

                    me.current += '-';
                } else if (key === '±') {

                    if (me.current.charAt(0) === '-') {
                        me.current = me.current.slice(1);
                    } else {
                        me.current = '-' + me.current;
                    }
                } else if (key === '<=') {

                    me.current = me.current.substring(0, me.current.length - 1);
                } else if (key === '%') {

                    me.current = me.current / 100;
                } else if (key === 'π') {

                    me.current = me.current * Math.PI;
                } else if (key === 'x ²') {

                    me.current = eval(me.current * me.current);
                } else if (key === '√') {

                    me.current = Math.sqrt(me.current);
                } else if (key === 'sin') {

                    me.current = Math.sin(me.current);
                } else if (key === 'cos') {

                    me.current = Math.cos(me.current);
                } else if (key === 'tan') {

                    me.current = Math.tan(me.current);
                } else if (key === 'log') {

                    me.current = Math.log10(me.current);
                } else if (key === 'ln') {

                    me.current = Math.log(me.current);
                } else if (key === 'x^') {

                    me.current += '^';
                } else if (key === 'x !') {

                    var number = 1;
                    if (me.current === 0) {
                        me.current = '1';
                    } else if (me.current < 0) {
                        me.current = NaN;
                    } else {
                        var _number = 1;
                        for (var i = me.current; i > 0; i--) {
                            _number *= i;
                        }
                        me.current = _number;
                    }
                } else if (key === 'e') {

                    me.current = Math.exp(me.current);
                } else if (key === 'rad') {

                    me.current = me.current * (Math.PI / 180);
                } else if (key === '∘') {

                    me.current = me.current * (180 / Math.PI);
                }
            },
            //全屏
            buttoncli() {
                // 需要注意的是 如果判断!screenfull.enabled 显示的是不支持全屏的话 是因为谷歌的版本问题  判断改为 !screenfull.isEnabled  就可以了

                if (!screenfull.isEnabled) { // 如果不允许进入全屏，发出不允许提示
                    this.$message({
                        message: '不支持全屏',
                        type: 'warning'
                    })
                    return false
                }
                screenfull.toggle()
                this.isFullscreen = true
            },
            //点击字号 减小
            clickSmall() {
                let postFontSize = this.postFontSize
                if (postFontSize > 14) {
                    this.postFontSize--
                } else {
                    this.$message({
                        message: '已经是最小字体了哦',
                        type: 'warning'
                    });
                    return
                }
            },
            //点击字号 放大
            clickBig() {
                let postFontSize = this.postFontSize
                if (postFontSize < 30) {
                    this.postFontSize++
                } else {
                    this.$message({
                        message: '已经是最大字体了哦',
                        type: 'warning'
                    });
                    return
                }
            },


            //倒计时时间到
            endFn() {
                this.handelPost()
                this.ceshi = '测试结束'
                let postexam = this.postexam

                PostAddByData(postexam).then(res => {
                    console.log(res)
                    this.hand_roll = false
                    this.hint_show = !this.hint_show
                })
            },
            // 调用摄像头
            callCamera() {
                let that = this;

                if (that.is_facility === false) {
                    that.$message.warning('没有拍摄设备');
                    return
                }
                // H5调用电脑摄像头API
                navigator.mediaDevices.getUserMedia({
                    video: true
                }).then(success => {
                    // 摄像头开启成功
                    this.$refs['video'].srcObject = success
                    // // 实时拍照效果
                    this.$refs['video'].play()
                })
            },
            //检测摄像头是否存在
            checkshebei() {
                let that = this;
                if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                    // Firefox 38+ seems having support of enumerateDevicesx
                    navigator.enumerateDevices = function (callback) {
                        navigator.mediaDevices.enumerateDevices().then(callback);
                    };
                }
                var MediaDevices = [];
                var isHTTPs = location.protocol === 'https:';
                var canEnumerate = false;

                if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
                    canEnumerate = true;
                } else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
                    canEnumerate = true;
                }

                var hasMicrophone = false;
                var hasSpeakers = false;
                var hasWebcam = false;

                var isMicrophoneAlreadyCaptured = false;
                var isWebcamAlreadyCaptured = false;

                function checkDeviceSupport(callback) {
                    if (!canEnumerate) {
                        return;
                    }

                    if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
                        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
                    }

                    if (!navigator.enumerateDevices && navigator.enumerateDevices) {
                        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
                    }

                    if (!navigator.enumerateDevices) {
                        if (callback) {
                            callback();
                        }
                        return;
                    }

                    MediaDevices = [];
                    navigator.enumerateDevices(function (devices) {
                        devices.forEach(function (_device) {
                            var device = {};
                            for (var d in _device) {
                                device[d] = _device[d];
                            }

                            if (device.kind === 'audio') {
                                device.kind = 'audioinput';
                            }

                            if (device.kind === 'video') {
                                device.kind = 'videoinput';
                            }

                            var skip;
                            MediaDevices.forEach(function (d) {
                                if (d.id === device.id && d.kind === device.kind) {
                                    skip = true;
                                }
                            });

                            if (skip) {
                                return;
                            }

                            if (!device.deviceId) {
                                device.deviceId = device.id;
                            }

                            if (!device.id) {
                                device.id = device.deviceId;
                            }

                            if (!device.label) {
                                device.label = 'Please invoke getUserMedia once.';
                                if (!isHTTPs) {
                                    device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
                                }
                            } else {
                                if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
                                    isWebcamAlreadyCaptured = true;
                                }

                                if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
                                    isMicrophoneAlreadyCaptured = true;
                                }
                            }

                            if (device.kind === 'audioinput') {
                                hasMicrophone = true;
                            }

                            if (device.kind === 'audiooutput') {
                                hasSpeakers = true;
                            }

                            if (device.kind === 'videoinput') {
                                hasWebcam = true;
                            }

                            // there is no 'videoouput' in the spec.

                            MediaDevices.push(device);
                        });

                        if (callback) {
                            callback();
                        }
                    });
                }

                //end

                checkDeviceSupport(function () {
                    if (hasWebcam == false) {
                        that.$notify({
                            title: '提示',
                            message: '系统未检测到摄像头,请安装摄像头！',
                            duration: 0
                        });
                        that.is_facility = false
                        return false;
                    }
                    if (hasMicrophone == false) {
                        // console.log("没有麦克风！");
                        return false;
                    } else {
                        if (isMicrophoneAlreadyCaptured == false) {
                            // console.log("捕获麦克风失败，请重新安装麦克风！");
                            return false;
                        }
                    }
                });
            },
            changeRadio(e) {
                console.log(e, "eeeeee")
                let index = e
                let combination = this.combination
                console.log(combination, "combination1111")
                for (let i = 0; i < combination.length; i++) {
                    if (i == index) {
                        let clength = 0
                        for (let j = 0; j < combination[i].data.length; j++) {
                            if (Array.isArray(combination[i].data[j].select)) {
                                if (combination[i].data[j].select.length > 0) {
                                    clength++
                                }
                            } else if (combination[i].data[j].select !== null) {
                                clength++
                            }
                        }
                        if (clength > 0) {
                            combination[i].is_pitch = true
                        } else {
                            combination[i].is_pitch = false
                        }
                    }
                    this.combination = combination
                }
            },
            //单击选择左侧题目
            clickSingle(index, type) {
                console.log(index, type)
                this.cindex = index
                this.type = type
            },
            //上一题
            oNup() {
                let cindex = this.cindex
                let type = this.type
                console.log(cindex, type)
                if (cindex <= 0) {
                    this.$message({
                        message: type + '没有上一题了哦！',
                        type: 'warning'
                    });
                } else {
                    this.cindex--
                }

            },
            //下一题
            oNnext() {
                let cindex = this.cindex
                let type = this.type

                let onelist = this.onelist.length  //单选题
                let judge = this.judge.length  //判断题
                let morelist = this.morelist.length //  多选题
                let combination = this.combination.length  //案例分析题
                if (type == '单选题') {
                    if (cindex == onelist - 1) {
                        this.$message({
                            message: type + '没有下一题了哦！',
                            type: 'warning'
                        });
                    } else {
                        this.cindex++
                    }
                } else if (type == '多选题') {
                    if (cindex == morelist - 1) {
                        this.$message({
                            message: type + '没有下一题了哦！',
                            type: 'warning'
                        });
                    } else {
                        this.cindex++
                    }
                } else if (type == '判断题') {
                    if (cindex == judge - 1) {
                        this.$message({
                            message: type + '没有下一题了哦！',
                            type: 'warning'
                        });
                    } else {
                        this.cindex++
                    }
                } else if (type == '案例分析题') {
                    if (cindex == combination - 1) {
                        this.$message({
                            message: type + '没有下一题了哦！',
                            type: 'warning'
                        });
                    } else {
                        this.cindex++
                    }
                }

            },
        }
    }
</script>
<style lang="scss" scoped>
  .index {
    .index_title {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #549ced;
      color: #fff;
      font-size: 20px;
      font-width: 500;
      z-index: 100;

      .index_title_box {
        position: relative;

        .index_title_img {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
      }
    }

    .index_message {
      position: fixed;
      left: 0;
      right: 0;
      top: 50px;
      z-index: 100;
      border-bottom: 1px solid #eee;
      height: 60px;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .message_left {
        display: flex;
        flex-direction: column;
        font-size: 13px;

        .message_left_name {
          position: relative;

          .message_left_name_hr {
            position: absolute;
            left: 0;
            top: 8px;
            width: 100%;
            background: #eceef1;
            height: 1px;
          }
        }

        .message_left_de {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 5px;

          .name {
            margin-right: 10px;
          }
        }
      }

      .message_right {
        font-size: 13px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .name {
          margin-right: 10px;

          span {
            margin-left: 5px;
            font-weight: bold;
            color: red;
            margin-right: 12PX;
            font-size: 14px;
          }
        }

        /deep/ .count {
          span {
            font-weight: bold;
            color: red;
            font-size: 29px;
            font-family: -webkit-pictograph;
          }
        }

        .counter {
          cursor: pointer;
          margin-left: 10px;
          background-color: #2a7fff;
          height: 30px;
          line-height: 30px;
          text-align: center;
          padding: 0 10px;
          color: #fff;
          font-size: 13px;
          border-radius: 4px;
          position: relative;
          overflow: hidden;
        }

        .counter:after {
          content: '';
          display: block;
          position: absolute;
          top: -36px;
          left: -100px;
          background: white;
          width: 50px;
          height: 125px;
          opacity: 20%;
          transform: rotate(-45deg);
        }

        .counter:hover:after {
          left: 120%;
          transition: all 600ms cubic-bezier(0.3, 1, 0.2, 1);
          -webkit-transition: all 600ms cubic-bezier(0.3, 1, 0.2, 1);
        }
      }
    }

    .index_main {

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 110px 0 20px;

      .main_left {
        width: 11%;
        padding: 0 5px;

        .main_left_centent {
          overflow-y: auto;
          height: 79vh;

          .one {
            margin-bottom: 20px;

            .one_title {
              font-weight: bold;
              color: #333;
              font-size: 13px;
              margin-left: 10px;
              padding-bottom: 5px;
              position: relative;
              margin-top: 10px;

              .one_title_hr {
                position: absolute;
                left: 0;
                top: 10px;
                width: 90%;
                background: #eceef1;
                height: 1px;
              }
            }

            .one_name {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              margin-top: 10px;
              margin-bottom: 20px;

              .name_value {
                cursor: pointer;
                margin-right: 8px;
                margin-bottom: 10px;
                width: 30px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                border: 1px solid #999999;
                box-sizing: border-box;
                /*background-color: #eee;*/
                font-size: 12px;

                &:nth-child(5n) {
                  margin-right: 0;
                }

                &:hover {
                  background-color: #000cff;
                  color: #fff;
                }
              }

              .name_value.name_value_blue {
                background-color: #000cff;
                color: #fff;
              }

              .name_value_green {
                background-color: #a9ea25;
                color: #333;
              }

              .name_value_check {
                background-color: #fc211c;
                color: #333;
              }
            }
          }
        }

        .examine {
          margin-top: 16px;
        }

      }

      .main_centre {
        width: 75%;

        .centre_answer {
          height: 79vh;
          overflow-y: auto;
          border: 2px solid #1a8ff8;
          box-sizing: border-box;
          position: relative;

          .size_of_the {
            position: absolute;
            top: 40px;
            right: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .icon {
              width: 30px;
              height: 30px;
              margin-left: 10px;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .answer_hint {
            padding-left: 10px;
            height: 30px;
            line-height: 30px;
            background-color: #2a7fff;
            color: #fff;
          }

          .answer_single {
            margin-left: 10px;
            margin-top: 10px;
            font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
            .single_title {
              display: flex;
              width: 85%;

              .is_hint {
                cursor: pointer;
                color: #1a8ff8;
                font-weight: bold;
              }
            }

            .single_radio {
              margin-top: 10px;
              margin-bottom: 20px;
              .single_radio_group {
                display: grid;
                .el-radio {
                  margin-top: 10px;
                }
                /deep/ .el-radio {
                  color: #333 !important;
                  font-weight: normal !important;
                  /*font-size: 12px !important;*/
                }
                .single_radio_group_tu {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  .radio_img {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    img {
                      margin-left: 10px;
                      width: 150px;
                      height: 100px;
                    }
                  }
                }
              }
              .single_checkbox-group {
                display: grid;

                /deep/ .el-checkbox {
                  margin-top: 10px;
                  color: #333 !important;
                  font-weight: normal !important;
                  font-size: 12px !important;
                }

              }
            }

            .single_imgs {
              margin: 10px 0;
              width: 200px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .single_answer {
              margin-left: 10px;
              margin-bottom: 10px;

              .answe_a {
                span {
                  color: #333;
                }
              }

              .answer_b {
                margin-top: 10px;

                .no_size {
                  margin-top: 10px;
                  margin-left: 10px;
                }
              }
            }

            .single_case {
              width: 85%;
              margin: 10px 0;


              color: #333;
            }

            .single_bgimg {
              margin-top: 10px;
              margin-left: 20px;
              width: 250px;
              height: 150px;

              img {
                cursor: pointer;
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .centre_operate {
          margin: 10px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          .operate_up {
            display: flex;
            flex-direction: row;

            .operate_up_c {
              cursor: pointer;
              padding: 0 10px;
              height: 25px;
              line-height: 25px;
              text-align: center;
              font-size: 12px;
              color: #fff;
              background-color: #009dff;
              border-radius: 5px;
              margin-right: 20px;
              position: relative;
            }

            .operate_up_c:before {
              content: '';
              display: block;
              background: linear-gradient(to left, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.4) 50%);
              background-size: 210% 100%;
              background-position: right bottom;
              height: 100%;
              width: 100%;
              position: absolute;
              top: 0;
              bottom: 0;
              right: 0;
              left: 0;
              transition: all 1s;
              -webkit-transition: all 1s;
            }

            .operate_up_c:hover:before {
              background-position: left bottom;
            }
          }

          .operate_deal {
            cursor: pointer;
            padding: 0 10px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 12px;
            color: #fff;
            background-color: #009dff;
            position: relative;
            border-radius: 4px;
          }

          .operate_deal:before {
            content: '';
            display: block;
            background: linear-gradient(to left, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.4) 50%);
            background-size: 210% 100%;
            background-position: right bottom;
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            transition: all 1s;
            -webkit-transition: all 1s;
          }

          .operate_deal:hover:before {
            background-position: left bottom;
          }
        }
      }

      .main_right {
        width: 15%;

        .main_right_hint {
          background-color: #2a7fff;
          height: 32px;
          line-height: 32px;
          text-align: center;
          color: #fff;
        }

        .main_right_play {
          padding: 0 10px;

          .paly_video {
            margin-top: 10px;
            width: 100%;
            margin-bottom: 10px;
            border: 2px solid #333;
            box-sizing: border-box;

            .ta_video {
              object-fit: fill;
            }
          }

          .is_camera {
            height: 240px;
            line-height: 240px;
            border: 2px solid #333;
            box-sizing: border-box;
            text-align: center;
            color: red;
          }

          .paly_take {
            margin: 0 auto;
            width: 100%;
            height: 240px;
            border: 2px solid #333;
            box-sizing: border-box;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .paly_notice {
            margin-top: 10px;
            color: red;
            font-size: 14px;
            font-weight: bold;

            .notice_cent {
              font-size: 12px;
              text-indent: 2em;
            }
          }
        }
      }
    }

    .index_roll {
      position: fixed;
      left: 35%;
      top: 35%;
      z-index: 999;
      width: 385px;
      border-radius: 4px;
      overflow: hidden;
      background-color: #fff;

      .head {
        height: 42px;
        background-color: #fdbc3e;
        color: #fff;
        font-size: 18px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .head_title {
          margin-left: 20px;
        }

        .head_icon {
          margin-right: 15px;
          font-size: 18px;
          cursor: pointer;

          i {
            font-weight: bold;
          }
        }
      }

      .hint {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 60px;

        .hint_img {
          width: 50px;
          height: 50px;
          margin-left: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .hint_name {
          margin-left: 20px;
        }
      }

      .operation {
        height: 40px;
        background-color: #eff1ee;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .operation_on {
          cursor: pointer;
          width: 70px;
          margin-right: 20px;
        }
      }
    }

    .index_reminder {
      position: fixed;
      left: 35%;
      top: 35%;
      background-color: #fff;
      z-index: 999;
      width: 385px;
      height: 245px;
      border: 2px solid #157fe6;
      border-radius: 4px;

      .head {
        height: 42px;
        line-height: 42px;
        background-color: #157fe6;
        color: #fff;
        font-size: 18px;
        text-align: center;
      }

      .grade {
        margin-top: 50px;
        text-align: center;
        font-size: 20px;
        color: #333;

        span {
          color: red;
          font-size: 35px;
          font-weight: 500;
          font-family: ui-serif;
          margin-left: 12px;
        }
      }

      .confirm {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .confirm_hr {
          width: 100px;
          height: 2px;
          background-color: #eee;
        }

        .confirm_on {
          cursor: pointer;
          width: 61px;
          height: 40px;
          padding: 0 20px;
          line-height: 40px;
          text-align: center;
          background-color: #3098fb;
          margin: 0 2px;
          color: #fff;
          font-size: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }


    .index_calculator {
      position: fixed;
      left: 50%;
      top: 35%;
      z-index: 999;
      cursor: move;
      .calculator {
        width: 390px;
        padding: 5px 10px 8px;
        border-radius: 5px;
        margin: 20px auto;
        font-size: 16px;
        background-color: #fff;
        border: 1px solid #333;
        position: relative;
      }
      .calculator_close {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 14px;
        color: #999999;
        cursor: pointer;
        i {
          font-weight: bold;
        }
      }
      .results_value {
        width: 370px;
        height: 45px;
        background-color: #fff;
        color: #333;
        padding: 55px 5px 0 5px;
        margin: 0 0px 10px 10px;
        font-size: 30px;
        text-align: right;
        font-weight: bold;
      }

      .button {
        margin: 3px 3px 4px 3px;
        width: 90px;
        border: 1px solid #333;
        height: 45px;
        border-radius: 4px;
        color: #000;
        font-weight: bold;
        cursor: pointer;
        outline: none;
        background-color: #fff;
        font-size: 21px;
      }

      .mode {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
      }

      .toggle-button {
        border: none;
        background-color: #fff;
        cursor: pointer;
        outline: none;
        font-size: 1rem;
        color: #333;
      }

      p {
        margin-top: 0;
        font-size: 13px;
        font-weight: bold;
      }

      button::-moz-focus-inner {
        border-color: transparent;
      }
    }

  }
</style>
